import { GenericResponse } from "../business-entities/generic-response";
import { Urls } from "../../../../Autofacets-Core/src/app/utils/urls";
import { DataService } from "../../../../Autofacets-Core/src/app/services/data.service";
import { Injectable } from "@angular/core";
import { LaborListRequestModel } from "../business-entities/labor-details-view-model";

@Injectable({
    providedIn: 'root'
})

export class LaborDataService {
    constructor(private dataProvider: DataService) {
    }

    async getLaborList(requestModel: LaborListRequestModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetLaborList, requestModel).toPromise();
    }
    getLaborById(Id: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetLaborById, Id).toPromise();
    }

    AddUpdateLabor(LaborModel: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddUpdateLabor, LaborModel).toPromise();
    }

    async ResyncLabor(id: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.RysyncLabor, id).toPromise();
    }
    
    async getSearchLabor(model: any): Promise<any> {
        return this.dataProvider.Post<any>(Urls.GetSearchLabor, model).toPromise();
    }
    async getChargingGroupDropDown(): Promise<any> {
        return this.dataProvider.Get<any>(Urls.GetChargingGroupDropDownList).toPromise();
    }
}